import React from 'react'
import LoginForm from '../Components/LoginForm/LoginForm'
import login from '../assets/licensed-image.png'
import { Col, Container, Row } from 'react-bootstrap'

function Login() {
  return (
    <div className='h-100'>
<Container className='h-100'>
<Row className='h-100'>
  <Col md={6} className='img_container_grid h-100'>
  <div className='d-flex justify-content-center h-100 align-items-center'>
    <img src={login}alt=''className='h-75'/>
  </div>
  </Col>
  <Col md={6}>     
     <LoginForm />
</Col>
</Row>
</Container>
    </div>
  )
}

export default Login
